import { type VariantProps, cva } from "class-variance-authority";
import type { HTMLAttributes } from "react";
import { cn } from "../../lib/utils";

const badgeVariants = cva(
  "inline-flex items-center rounded-full border px-2 py-0.5 text-xs font-medium transition-colors",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-(--accent-100) text-(--accent-700) dark:bg-(--accent-700) dark:text-(--accent-50)",
        outline: "border-(--border-strong) text-(--text-secondary)",
        success: "border-transparent bg-(--success) text-white",
        warning: "border-transparent bg-(--warning) text-white",
        error: "border-transparent bg-(--error) text-white",
        muted: "border-transparent bg-(--bg-elevated) text-(--text-secondary)",
      },
    },
    defaultVariants: { variant: "default" },
  },
);

interface BadgeProps extends HTMLAttributes<HTMLSpanElement>, VariantProps<typeof badgeVariants> {}

export function Badge({ className, variant, ...props }: BadgeProps) {
  return <span className={cn(badgeVariants({ variant }), className)} {...props} />;
}
